import { IndustryTemplate } from '@/components';
import { paintingContent } from '@/data/industries/painting';

export function PaintingPage() {
  return <IndustryTemplate content={paintingContent} />;
}
